import { useEffect, useState } from "react";
import { api } from "../lib/api";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { AlertCircle, Phone, Mail, Gift } from "lucide-react";

export default function SRH01() {
  const [d, setD] = useState(null);
  useEffect(() => {
    document.title = "SRH01 Servizi di Consulenza | Betelgez";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement("meta"); meta.name = "description"; document.head.appendChild(meta); }
    meta.content = "CSR Sardegna 2023/2027 - Intervento SRH01. Servizi di consulenza per le imprese agricole erogati da Betelgez.";
    api.get("/page/srh01").then((r) => setD(r.data)).catch(() => setD({}));
  }, []);
  if (!d) return <div className="h-screen flex items-center justify-center text-[#6B7280]">Caricamento…</div>;

  return (
    <div data-testid="page-srh01">
      {/* Loghi ufficiali */}
      <section className="pt-16 md:pt-24 pb-12 md:pb-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-3xl border border-[#E5E7EB] p-6 md:p-10 flex items-center justify-center">
            {d.loghi_image && (
              <img
                src={d.loghi_image}
                alt="FEASR · Repubblica Italiana · CSR Sardegna 2023-2027"
                className="max-w-full h-auto max-h-40 md:max-h-48 object-contain"
              />
            )}
          </div>
        </div>
      </section>

      {/* Titolo */}
      <section className="pb-12 md:pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[1.05] text-[#1A1A1A]">
            {d.title}
          </h1>
          <p className="mt-5 text-xl md:text-2xl font-display font-semibold text-[#007A3D] tracking-tight">
            {d.subtitle}
          </p>

          {/* Badge Totalmente Gratuito */}
          <div className="mt-8 flex justify-center">
            <div
              data-testid="srh01-free-badge"
              className="inline-flex items-center gap-3 bg-[#007A3D] text-white rounded-full px-6 py-3 md:px-8 md:py-4 shadow-[0_15px_40px_-10px_rgba(0,122,61,0.55)]"
            >
              <Gift className="w-5 h-5 md:w-6 md:h-6" />
              <span className="font-display font-black tracking-wide uppercase text-sm md:text-base">
                Servizio Totalmente Gratuito
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Boxes */}
      <section className="pb-16 md:pb-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <div data-testid="srh01-box-1" className="bg-white rounded-3xl border border-[#E5E7EB] shadow-sm hover-lift p-8 md:p-10 flex flex-col">
            <h2 className="font-display font-bold text-2xl md:text-3xl tracking-tight text-[#1A1A1A]">{d.box1_title}</h2>
            <div className="mt-6 flex-1 flex items-center justify-center text-center prose-betelgez">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  p: ({ node, ...props }) => <p {...props} className="m-0" />,
                  a: ({ node, ...props }) => (
                    <a
                      {...props}
                      target={props.href?.startsWith("http") ? "_blank" : undefined}
                      rel={props.href?.startsWith("http") ? "noopener noreferrer" : undefined}
                      download={props.href?.endsWith(".pdf") ? "" : undefined}
                      className="font-display font-bold text-3xl md:text-5xl tracking-tight text-[#007A3D] hover:text-[#00A651] underline underline-offset-[6px] decoration-2 transition-colors"
                    />
                  ),
                }}
              >{d.box1_text || ""}</ReactMarkdown>
            </div>
          </div>
          <div data-testid="srh01-box-2" className="bg-white rounded-3xl border border-[#E5E7EB] shadow-sm hover-lift p-8 md:p-10 flex flex-col">
            <h2 className="font-display font-bold text-2xl md:text-3xl tracking-tight text-[#1A1A1A]">{d.box2_title}</h2>
            <div className="mt-6 flex-1 flex items-center justify-center text-center prose-betelgez">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  p: ({ node, ...props }) => <p {...props} className="m-0" />,
                  a: ({ node, ...props }) => (
                    <a
                      {...props}
                      target={props.href?.startsWith("http") ? "_blank" : undefined}
                      rel={props.href?.startsWith("http") ? "noopener noreferrer" : undefined}
                      className="font-display font-bold text-3xl md:text-5xl tracking-tight text-[#007A3D] hover:text-[#00A651] underline underline-offset-[6px] decoration-2 transition-colors"
                    />
                  ),
                }}
              >{d.box2_text || ""}</ReactMarkdown>
            </div>
          </div>
        </div>
      </section>

      {/* Scadenza + CTA rossa */}
      <section className="pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 text-[#B91C1C] font-display font-bold text-sm uppercase tracking-[0.2em]" data-testid="srh01-deadline-label">
            <AlertCircle className="w-4 h-4" />
            Scadenza
          </div>
          <h2 className="mt-4 font-display font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[1.05] text-[#1A1A1A]">
            31 Luglio 2026
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#6B7280] max-w-xl mx-auto">
            Non perdere l'opportunità. Affidati a Betelgez per la presentazione della tua domanda di consulenza SRH01.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:+393462461457"
              data-testid="srh01-contact-cta"
              className="inline-flex items-center gap-2.5 bg-[#DC2626] hover:bg-[#B91C1C] text-white rounded-full px-9 py-5 font-display font-bold text-base md:text-lg tracking-wide uppercase shadow-[0_15px_40px_-10px_rgba(220,38,38,0.55)] hover:shadow-[0_18px_45px_-8px_rgba(185,28,28,0.65)] transition-all hover:-translate-y-0.5"
            >
              Contattaci ora <Phone className="w-5 h-5" />
            </a>
            <a
              href="mailto:betelgez71@gmail.com"
              data-testid="srh01-email-cta"
              className="inline-flex items-center gap-2.5 bg-white hover:bg-[#F9FAFB] text-[#1A1A1A] border-2 border-[#1A1A1A] rounded-full px-9 py-5 font-display font-bold text-base md:text-lg tracking-wide transition-all hover:-translate-y-0.5"
            >
              <Mail className="w-5 h-5" />
              betelgez71@gmail.com
            </a>
          </div>

          <p className="mt-6 text-sm md:text-base text-[#6B7280]">
            Scrivici a <a href="mailto:betelgez71@gmail.com" className="font-semibold text-[#007A3D] hover:text-[#00A651] underline underline-offset-4">betelgez71@gmail.com</a> per richiedere assistenza — <span className="font-semibold text-[#1A1A1A]">servizio completamente gratuito</span>.
          </p>
        </div>
      </section>
    </div>
  );
}
